// extracted by mini-css-extract-plugin
export default {"EmailSend":"EmailSend_EmailSend__73WhJ"};